import React from "react";

const Hero = () => (
	<section className="hero-section py-20 text-center">
		<div className="max-w-4xl mx-auto px-4">
			<h2 className="text-4xl md:text-6xl font-bold mb-4 text-white">
				Reliable IT Solutions for the Modern World
			</h2>
			<p className="text-2xl font-semibold text-lime-400 mb-6">
				Trivnet Services Limited delivers smart, scalable, and secure IT
				services to help you grow your business.
			</p>
			<a
				href="#contact"
				className="bg-violet-900 text-white px-6 py-3 rounded shadow hover:bg-violet-950"
			>
				Get in Touch
			</a>
		</div>
	</section>
);

export default Hero;
